/** @format */

export type ByGoalDate = Record<number, Record<string, number>>;

const getLatestDateIndex = (data: ByGoalDate, rechartsDates: string[]): number => {
  if (!rechartsDates.length) {
    return -1;
  }

  const datesSet = new Set<string>();

  Object.values(data).forEach(goalData => {
    Object.keys(goalData).forEach(date => {
      datesSet.add(date);
    });
  });

  // Если данных нет ни по одной дате — берем последний индекс из rechartsDates
  if (datesSet.size === 0) {
    return rechartsDates.length - 1;
  }

  // Сортируем даты по возрастанию (ISO-формат YYYY-MM-DD сортируется лексикографически корректно)
  const sortedDates = Array.from(datesSet).sort();

  // Самая свежая дата с данными
  const latestDate = sortedDates[sortedDates.length - 1];

  // 1. Если эта дата есть в rechartsDates — берем её индекс
  const sameDateIndex = rechartsDates.indexOf(latestDate);
  if (sameDateIndex !== -1) {
    return sameDateIndex;
  }

  // 2. Если последней даты с данными нет в rechartsDates,
  //    берем первую дату в rechartsDates, которая СВЕЖЕЕ
  for (let i = 0; i < rechartsDates.length; i++) {
    if (rechartsDates[i] > latestDate) {
      return i;
    }
  }

  // 3. Если в rechartsDates нет дат свежее — берем последний индекс
  return rechartsDates.length - 1;
};

export {getLatestDateIndex};
